import { defineMessages } from 'react-intl'

const scope = `procurify.vendor.features.create-vendor-payment-method.presenters.CreateVendorPaymentMethodFormPresenter`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'Payment method has been added',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Something went wrong. Please try again.',
  },
})
